import React from "react";
import { FilterComponentProps } from "../utils/Type";
import { ClearButtonFilter, Icon, SearchWrapper, TextFieldWithIcon } from "../utils/StyledComponents";

const FilterComponent: React.FC<FilterComponentProps> = ({ filterText, btnClear = true, onFilter, onClear }) => (
  <SearchWrapper className="me-3">
    <Icon size={16} />
    <TextFieldWithIcon
      id="search"
      type="text"
      placeholder="Rechercher..."
      aria-label="recherche"
      value={filterText}
      onChange={onFilter}
    />
    {btnClear && (<ClearButtonFilter onClick={onClear}>×</ClearButtonFilter>)}
  </SearchWrapper>
);

export default FilterComponent;